import * as React from "react";
import { useEffect, useState } from "react";
import Swal from 'sweetalert2';
import { NotificationSound } from "./CommonNotification";
import { CommonApiData, base64ToBlob, virtualPath } from "./EnvConfig";
import CryptoJS from 'crypto-js';
import { GetSession } from "./criptoUtils";


export const pathName = (() => {
    const pathName = window.location?.pathname || '/';
    const segments = pathName.split('/').filter(Boolean);
    return segments.some(segment => segment.toLowerCase() === 'admin');
})();

export const sanitizeInput = (value) => {
    return value.replace(/["']/g, "");
};


export const setFavicon = (base64Icon) => {
    if (!base64Icon.startsWith("data:")) {
        console.error("Invalid base64 icon string");
        return;
    }

    let link = document.getElementById("favicon-link") || document.querySelector("link[rel~='icon']");

    if (link) {
        link.href = base64Icon;
    } else {
        const newLink = document.createElement("link");
        newLink.rel = "icon";
        newLink.id = "favicon-link";
        newLink.href = base64Icon;
        document.head.appendChild(newLink);
    }
};


export const projectLogo = () => {
    let getLogoName = GetSession('cookies', 'projectlogo') || 'main-logo.jpeg';
    return getLogoName;
};

export function convertTwoDecimalsOnValue(value) {
    const regex = /([0-9]*[\.]{0,1}[0-9]{0,2})/s;
    return value.match(regex)[0];
}
export function convertThreeDecimalsOnValue(value) {
    const regex = /([0-9]*[\.]{0,1}[0-9]{0,3})/s;
    return value.match(regex)[0];
}
export function convertPercenatge(value) {
    const regex = /^(\d{1,2})(\.\d{0,2})?$/;
    if (regex.test(value)) {
        return value;
    }
    return value.slice(0, -1);
}
export function convertThreeDecimalsWithoutZero(value) {
    const regex = /^(?!0\d*\.?)\d*(?:[.,]\d{0,3})?/;
    const match = value.match(regex);
    return match ? match[0] : "";
}

let previousValue = "";
export function ConvertToCharacterCaseOne(value) {
    let regex = /^[a-zA-Z0-9\/_\-]*$/;
    let matchResult = value.match(regex);
    if (matchResult !== null) {
        previousValue = matchResult[0];
        return matchResult[0];
    } else {
        return previousValue;
    }
}
export function ConvertToBlobPDF(value) {
    value = value.split(",")[1]
    const binStr = atob(value);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
    }
    let pdfBlob = new Blob([arr], { type: 'application/pdf' });
    const url = URL.createObjectURL(pdfBlob);
    sessionStorage.setItem('pdfBlobUrl', url);
    const pdfWindow = window.open(url, '_blank');
    if (!pdfWindow) {
        throw new Error("Please allow pop-ups for this site");
    }
    pdfWindow.document.title = "View PDF";
}

let preValue = "";
export function ConvertToCharacterCaseTwo(value) {
    let regex = /^[a-zA-Z0-9\/_\-]*$/;
    let matchResult = value.match(regex);
    if (matchResult !== null) {
        preValue = value;
        return value;
    } else {
        return preValue;
    }
}

export const OpenImage = (fileBase64, ext) => {
    if ((ext).toLowerCase() === 'pdf') {
        const blob = base64ToBlob(fileBase64, 'application/pdf');
        const url = URL.createObjectURL(blob);
        const pdfWindow = window.open(url, '_blank');
        if (!pdfWindow) {
            throw new Error("Please allow pop-ups for this site");
        }
        pdfWindow.document.title = "View PDF";
    } else {
        const blob = base64ToBlob(fileBase64, 'image/jpeg');
        const url = URL.createObjectURL(blob);
        const imageWindow = window.open(url, '_blank');
        if (!imageWindow) {
            throw new Error("Please allow pop-ups for this site");
        }
        imageWindow.document.title = "View Image";
    }
}

export function convertDate(value) {
    const regex = /(?: (?: 31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})/;
    const match = value.match(regex);
    return match ? match[0] : "";
}
export function convertToNumber(value) {
    return value.replace(/[^0-9]/g, '');
}

export function convertToAlphaNumeric(value) {
    return value.replace(/[^a-zA-Z0-9]/g, '');
}

export function ValidAadhaarNumber(value) {
    return value.replace(/\D/g, "").replace(/(.{4})/g, "$1 ").trim();
}

export function convertToString(value) {
    return value;
}

export function properCase(inputString) {
    return inputString.replace(/[^a-zA-Z\s]/g, '').replace(/\b\w/g, function (match) {
        return match.toUpperCase();
    });
}

export function upperCase(inputString) {
    return inputString.replace(/[^a-zA-Z\s]/g, '').toUpperCase();
}
export function convertToDate(value) {
    return value.replace(/(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})/g, '');
}
export function convertToContactNumber(value) {
    return value.replace(/[^0-9+-]/g, '');
}

export function getAmountWithGST(Amount, gstRate) {
    if (Amount && gstRate) {
        return ((Number(Amount) * Number(gstRate)) / 100).toFixed(2);
    } else {
        return ''
    }
};

export function getDateAndTime1() {
    let pqrDate = new Date()
    let dateArr = pqrDate?.toString()?.split(' ')
    let curTime = dateArr[4]
    let curHHMM = curTime.split(':')
    curHHMM = `${curHHMM[0]}:${curHHMM[1]}`
    dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`
    return {
        time: curHHMM,
        date: dateArr
    }
};

export function getDateAndTime(a) {
    let pqrDate = new Date();
    pqrDate.setDate(pqrDate.getDate() - (Number(a) ? Number(a) : 0));

    let dateArr = pqrDate.toString().split(' ');
    let curTime = dateArr[4];
    let curHHMM = curTime.split(':');
    curHHMM = `${curHHMM[0]}:${curHHMM[1]}`;
    let formattedDate = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`;

    return {
        time: curHHMM,
        date: formattedDate
    };
}

export function convertStringToArray(arr, separator) {
    if (arr === undefined) {
        return 'Please Supply Valid String!'
    }
    if (arr === '') {
        return [];
    } else {
        let newArr = arr.split(separator);
        return newArr;
    }
};

export function formatDate(date) {
    const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    var day = ('0' + date.getDate()).slice(-2);
    var month = monthNames[date.getMonth()];
    var year = date.getFullYear();

    return day + '-' + month + '-' + year;
}


export const ApiCall = (url, bodyData) => {
    let { authToken, loginToken, loginUserCode, loginUserGroupID, ...rest } = bodyData;

    let Data = {
        ...rest,
        "authToken": CommonApiData().AuthToken,
        "loginToken": CommonApiData().loginToken,
        "loginUserCode": CommonApiData().loginUserCode,
        "loginUserGroupID": CommonApiData().loginUserGroupID,
        "loginCompanyCode": CommonApiData().companyCode,
        "source": "Web",
    }
    const abortController = new AbortController();
    let data = fetch(`${virtualPath + url}`, {
        method: 'POST',
        credentials: "include",
        body: JSON.stringify(Data),
        headers: {
            "Content-Type": "application/json"
            //"Authorization": `Bearer ${process.env.REACT_APP_SECRET_KEY}`
        },
        signal: abortController.signal
    }).then((res) => res.json())
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err
        }).finally(() => {
            abortController.abort();
        });
    return data
};

export const deleteData = (url, bodyData, RefereshApi, HandleClear, chargeType, inputref) => {

    let { AuthToken, LoginToken, UserCode, ...rest } = bodyData;
    let _Data = {
        ...rest,
        "authToken": CommonApiData().AuthToken,
        "loginToken": CommonApiData().loginToken,
        "loginUserCode": CommonApiData().loginUserCode,
        "Source": "Web"
    }
    if (typeof bodyData === 'object' && bodyData !== null) {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this record?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            keydownListenerCapture: true,
            stopKeydownPropagation: false,
            didOpen: () => {
                document.addEventListener('keydown', function (event) {
                    if (event.key === 'Y' || event.key === 'y') {
                        Swal.clickConfirm();
                    } else if (event.key === 'N' || event.key === 'n') {
                        Swal.clickCancel();
                    }
                });
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                const abortController = new AbortController();
                let Data = await fetch(`${virtualPath + url}`, {
                    method: 'POST',
                    body: JSON.stringify(_Data),
                    headers: {
                        "Content-Type": "application/json"
                    },
                    signal: abortController.signal
                }).then((res) => res.json())
                    .then(async (res) => {
                        if (res.status === 'SUCCESS') {
                            await NotificationSound(res.status, res.message, res.focus, inputref);
                            if (chargeType) {
                                RefereshApi(0, chargeType)
                            } else {
                                RefereshApi()
                            }
                            HandleClear()
                        } else {
                            await NotificationSound(res.status, res.message, res.focus, inputref);
                        }
                        return res;
                    })
                    .catch((err) => {
                        return err
                    }).finally(() => {
                        abortController.abort();
                    });
                return Data
            }
        });

    } else {
        NotificationSound('ERROR', 'Body Data is not valid JSON !');
    }
};

export const AutoCompleteList = (preFix, type, contextKey = '', contextKey2 = '', contextKey3 = '') => {
    const [data, setData] = useState({});
    const [error, setError] = useState({});
    const [loading, setLoading] = useState(true);

    let Data = {
        "authToken": CommonApiData().AuthToken,
        "loginToken": CommonApiData().loginToken,
        "loginUserCode": CommonApiData().loginUserCode,
    }
    useEffect(() => {
        const abortController = new AbortController();
        fetch('/api/AutoComplete/GetAutoComplete', {
            method: 'POST',
            body: JSON.stringify({ ...Data, type, preFix, contextKey, contextKey2, contextKey3 }),
            headers: {
                "Content-Type": "application/json"
            },
            signal: abortController.signal
        }).then((res) => res.json())
            .then((res) => {
                let dataList = [];
                let _datalist = res.dataList;
                for (let i = 0; i < _datalist?.length; i++) {
                    let _value = (_datalist[i]?.values);
                    dataList?.push(_value);
                }
                setData(dataList)
                setLoading(false)
            })
            .catch((err) => setError(err))
            .finally(() => {
                abortController.abort();
            });

    }, [type, preFix, contextKey, contextKey2, contextKey3])

    return { data, error, loading };
}

export const FetchAutoCompleteData = async (Data, preFix, type, contextKey = '', contextKey2 = '', contextKey3 = '', contextKey4 = '', contextKey5 = '') => {
    let { AuthToken, LoginToken, UserCode, CompanyCode, ...rest } = Data;
    let _Data = {
        ...rest,
        "authToken": CommonApiData().AuthToken,
        "loginToken": CommonApiData().loginToken,
        "loginUserCode": CommonApiData().loginUserCode,
    }
    let dataList = [];
    try {
        if (preFix !== undefined && preFix !== '') {
            const abortController = new AbortController();
            const response = await fetch(virtualPath + '/api/AutoComplete/AutoComplete', {
                method: 'POST',
                body: JSON.stringify({ ..._Data, Type: type, preFix, ContextKey: contextKey, ContextKey2: contextKey2, ContextKey3: contextKey3, ContextKey4: contextKey4, ContextKey5: contextKey5 }),
                headers: {
                    "Content-Type": "application/json"
                },
                signal: abortController.signal
            });

            const res = await response.json();

            let _datalist = res.autoCompleteData;
            for (let i = 0; i < _datalist?.length; i++) {
                let _value = (_datalist[i]?.values);
                dataList?.push(_value);
            }
            return dataList;
        }
        else {
            return [];
        }
    } catch (error) {
        console.error('Error fetching suggestions:', error);
        return [];
    }
};

export const DropDownData = (Type, ContextKey1 = '', ContextKey2 = '', Source = 'Web') => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState({});
    let Data = {
        "authToken": CommonApiData().AuthToken,
        "loginToken": CommonApiData().loginToken,
        "loginUserCode": CommonApiData().loginUserCode,
    };
    useEffect(() => {
        const abortController = new AbortController();
        fetch(virtualPath + '/api/AutoComplete/GetMasterData', {
            method: 'POST',
            body: JSON.stringify({ ...Data, Type, Source, ContextKey1, ContextKey2 }),
            headers: {
                "Content-Type": "application/json"
            },
            signal: abortController.signal
        }).then((res) => res.json())
            .then((res) => {
                setData(res)
                setLoading(false)
            })
            .catch((err) => {
                setError(err)
                setLoading(false)
            })
            .finally(() => {
                abortController.abort();
            });
    }, [Type, ContextKey1, ContextKey2])
    return { data, error, loading };
};


export const handleDateChange = (e, setFormData, formData, key) => {
    let dateArr = (e?.toString() || '').split(' ');
    if (dateArr.length >= 4) {
        dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`;
        setFormData({ ...formData, [key]: dateArr });
    } else {
        setFormData({ ...formData, [key]: '' });
    }
};

export const handleDateChangeNew = (e) => {
    let dateArr = (e?.toString() || '').split(' ');
    if (dateArr.length >= 4) {
        dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`;
        return dateArr
    } else {
        return dateArr = '';
    }
};

export const handleImgData = (selector, record, photoNameProp, photoExtProp) => {
    let elements = document.querySelectorAll(selector);
    if (elements.length > 0) {
        let element = elements[0];
        if (record[photoNameProp] !== '' && record !== '') {
            element.childNodes[2].innerHTML = `<span class="sc-fqkvVR kFhUBM">(${record[photoNameProp]}.${record[photoExtProp]})</span>`;
        } else {
            element.childNodes[2].innerHTML = `<span class="sc-fqkvVR kFhUBM"><span>Upload</span> or drop a file right here</span><span title="types: JPG,PNG" class="file-types">JPG,PNG</span>`;
        }
    }
}


export const FileUploadChild = (props) => {
    const { label = '', message = '', types = [], children, inputstyle } = props;
    return (
        <>

            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.33317 6.66667H22.6665V16H25.3332V6.66667C25.3332 5.196 24.1372 4 22.6665 4H5.33317C3.8625 4 2.6665 5.196 2.6665 6.66667V22.6667C2.6665 24.1373 3.8625 25.3333 5.33317 25.3333H15.9998V22.6667H5.33317V6.66667Z" fill="#0658C2"></path><path d="M10.6665 14.6667L6.6665 20H21.3332L15.9998 12L11.9998 17.3333L10.6665 14.6667Z" fill="#0658C2"></path><path d="M25.3332 18.6667H22.6665V22.6667H18.6665V25.3333H22.6665V29.3333H25.3332V25.3333H29.3332V22.6667H25.3332V18.6667Z" fill="#0658C2"></path></svg>
            <div className="sc-eqUAAy file-children" style={inputstyle}>
                {(message.trim() === '.' || message.trim() === '') ?
                    <span className="sc-fqkvVR"><span>{`Upload ${label}`}</span> or drop </span> :
                    <span className="sc-fqkvVR"><span className='text-success'>{`${message.substring(0, 4) + '...'}`}</span>uploaded !</span>
                }
                {(message.trim() !== '.' || message.trim() !== '') &&
                    <span title={`types: ${types.join()}`} className="file-types text-info">{types.join()}</span>
                }
                {children}
            </div>
        </>
    );
}

export const isValidDateFormat = (dateString) => {
    //-------- Regex to match DD-MMM-YYYY format (e.g., 01-Jan-2023) ----------//
    const dateRegex = /^(0[1-9]|[1-2][0-9]|3[0-1])-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-\d{4}$/;
    return dateRegex.test(dateString);
}

const secretKey = process.env.REACT_APP_PASS
export function encryptPassword(password) {
    const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(secretKey), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString(); // Base64 string
}